import { gql } from '@apollo/client'
import { SABRE_SIMPLE_PRODUCT_FRAGMENT } from '../fragments/SimpleProductFragment'

export const SABRE_GET_SIMPLE_PRODUCT = gql`
  query GetSimpleProduct($upc: String!) {
    product(upc: $upc) {
      ...SimpleProduct
    }
  }
  ${SABRE_SIMPLE_PRODUCT_FRAGMENT}
`
